import { ScannedCodeType } from 'app/features/scan-flow/models';
import { LocationType } from 'app/shared/features/location-selector/models';

export const getScannedCodeTitle = (allowedCodeType: ScannedCodeType) => {
    return scannedCodeTitle[allowedCodeType];
};

export const scannedCodeTitle: Record<ScannedCodeType, string> = {
    activity: 'GENERAL.TITLE.ACTIVITY',
    batch: 'GENERAL.TITLE.BATCH',
    container: 'GENERAL.TITLE.CONTAINER',
    employee: 'GENERAL.TITLE.EMPLOYEE',
    location: 'GENERAL.TITLE.LOCATION',
    'site-identifier': 'GENERAL.TITLE.SITE_IDENTIFIER',
};

export const scanCodeActionDescriptions: Record<ScannedCodeType, string> = {
    activity: 'SCAN.ACTION.TITLE.SCAN_ACTIVITY_CODE',
    batch: 'SCAN.ACTION.TITLE.SCAN_BATCH_CODE',
    container: 'SCAN.ACTION.TITLE.SCAN_CONTAINER_CODE',
    employee: 'SCAN.ACTION.TITLE.SCAN_EMPLOYEE_CODE',
    location: 'SCAN.ACTION.TITLE.SCAN_LOCATION_CODE',
    'site-identifier': 'SCAN.ACTION.TITLE.SCAN_SITE_CODE',
};

export const scannedCodeLocationTypeTitle: Record<LocationType, string> = {
    0: 'GENERAL.LOCATION_TYPE.OTHER',
    10: 'GENERAL.LOCATION_TYPE.SITE',
    20: 'GENERAL.LOCATION_TYPE.GREENHOUSE',
    25: 'GENERAL.LOCATION_TYPE.PACKHOUSE',
    30: 'GENERAL.LOCATION_TYPE.ROW',
    35: 'GENERAL.LOCATION_TYPE.PACKAGE',
    40: 'GENERAL.LOCATION_TYPE.CROP',
    45: 'GENERAL.LOCATION_TYPE.DOOR',
};
